export default __webpack_public_path__ + "static/hero-c1c990e9518c10fb0f7801b17a611b42.png";